import {inject, Injectable} from '@angular/core';
import Keycloak from 'keycloak-js';
import {RealmRole} from './role-check.service';

const SELECTED_PROVIDER_TENANT_KEY = 'selecthor-selected-provider-tenant';

@Injectable({
  providedIn: 'root',
})
export class ProviderTenantSelectionService {
  private readonly keycloak = inject(Keycloak);

  getSelectedTenantId(): string | null {
    if (!this.keycloak.authenticated || !this.keycloak.hasRealmRole(RealmRole.PROVIDER_MANAGER)) {
      return null;
    }
    const assignedTenantIds = this.getAssignedTenantIds();
    const storedTenantId = this.readStoredTenantId();
    return storedTenantId && assignedTenantIds.includes(storedTenantId)
      ? storedTenantId
      : (assignedTenantIds[0] ?? null);
  }

  selectTenant(tenantId: string): void {
    try {
      sessionStorage.setItem(SELECTED_PROVIDER_TENANT_KEY, tenantId);
      localStorage.setItem(SELECTED_PROVIDER_TENANT_KEY, tenantId);
    } catch {
      return;
    }
  }

  private getAssignedTenantIds(): string[] {
    const tenants = this.keycloak.tokenParsed?.['tenants'];
    return Array.isArray(tenants) ? tenants : [];
  }

  private readStoredTenantId(): string | null {
    try {
      return (
        sessionStorage.getItem(SELECTED_PROVIDER_TENANT_KEY) ??
        localStorage.getItem(SELECTED_PROVIDER_TENANT_KEY)
      );
    } catch {
      return null;
    }
  }
}
